import { render, staticRenderFns } from "./lowerSubparts.vue?vue&type=template&id=31122bb6&scoped=true&"
import script from "./lowerSubparts.vue?vue&type=script&lang=js&"
export * from "./lowerSubparts.vue?vue&type=script&lang=js&"
import style0 from "./lowerSubparts.vue?vue&type=style&index=0&id=31122bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31122bb6",
  null
  
)

export default component.exports